import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FacturaParaSepaDtoOut, FacturaSepaNoProcesableDtoOut, SepaDtoIn, SepaDtoOut } from '../models/sepa.model';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadSepaService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/contabilidad-onda/sepa`;

  constructor(private readonly http: HttpClient) {}

  getSepas(): Observable<SepaDtoOut[]> {
    return this.http.get<SepaDtoOut[]>(`${this.endpoint}`).pipe(catchError(this.handleError('getSepas')));
  }

  getSepaById(id: number): Observable<SepaDtoOut> {
    return this.http.get<SepaDtoOut>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('getSepaById')));
  }

  getFacturasParaSepa(empresaFacturadoraId: number): Observable<FacturaParaSepaDtoOut[]> {
    return this.http
      .get<FacturaParaSepaDtoOut[]>(`${this.endpoint}/facturas/${empresaFacturadoraId}`)
      .pipe(catchError(this.handleError('getFacturasParaSepa')));
  }

  crearSepa(sepa: SepaDtoIn): Observable<SepaDtoOut> {
    return this.http.post<SepaDtoOut>(`${this.endpoint}`, sepa).pipe(catchError(this.handleError('crearSepa')));
  }

  actualizarSepa(sepa: SepaDtoIn, id: number): Observable<SepaDtoOut> {
    return this.http
      .put<SepaDtoOut>(`${this.endpoint}/${id}`, sepa)
      .pipe(catchError(this.handleError('actualizarSepa')));
  }

  eliminarSepa(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('eliminarSepa')));
  }

  validarRemesaSepa(id: number): Observable<SepaDtoOut> {
    return this.http
      .put<SepaDtoOut>(`${this.endpoint}/${id}/validar-remesa-sepa`, {})
      .pipe(catchError(this.handleError('validarSepa')));
  }

  validarContabilidadSepa(id: number): Observable<SepaDtoOut> {
    return this.http
      .put<SepaDtoOut>(`${this.endpoint}/${id}/validar-contabilidad-sepa`, {})
      .pipe(catchError(this.handleError('validarSepa')));
  }

  getFacturasNoProcesables(): Observable<FacturaSepaNoProcesableDtoOut[]> {
    return this.http
      .get<FacturaSepaNoProcesableDtoOut[]>(`${this.endpoint}/facturas-no-procesables`)
      .pipe(catchError(this.handleError('getFacturasNoProcesables')));
  }

  exportarRemesaSepaExcel(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-remesa-excel`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarSepaExcel')));
  }

  exportarRemesaSepaCsv(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-remesa-csv`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarSepaCsv')));
  }

  exportarContabilidadSepaExcel(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-contabilidad-excel`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarSepaExcel')));
  }

  exportarContabilidadSepaCsv(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-contabilidad-csv`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarSepaCsv')));
  }

  cambiarCodigoAlbaran(sepaId: number, nuevoCodigoAlbaran: number): Observable<void> {
    return this.http
      .put<void>(`${this.endpoint}/${sepaId}/cambiar-codigo-albaran`, { nuevoCodigoAlbaran: nuevoCodigoAlbaran })
      .pipe(catchError(this.handleError('cambiarCodigoAlbaran')));
  }

  private handleError(operation: string) {
    return (error: any) => {
      console.error(`ContabilidadSepaService - Error en operación [${operation}]:`, error);
      throw error;
    };
  }
}
